import dispatcher from '../dispatcher';
import colorStore from '../color/color.store';

var color = null;
var html;

var _handleStore = function() {
	function componentToHex(c) {
		var hex = c.toString(16);
		return hex.length == 1 ? "0" + hex : hex;
	}

	function rgbToHex(cl) {
		return "#"
			+ componentToHex(parseInt(cl.x * 255))
			+ componentToHex(parseInt(cl.y * 255))
			+ componentToHex(parseInt(cl.z * 255));
	}

	var pw = document.getElementsByClassName('page-wrapper')[0];
	var colorData = colorStore.getData();
	var gradient;
	var gradientVect;
	var gradienMid;

	if (colorData.color === color) return;

	if (color) {
		pw.classList.remove('global-' + color);
	}

	color = colorData.color;
	gradient = colorData.gradientHex;
	gradientVect = colorStore.getData().gradientVector3;
	gradienMid = gradientVect[0].clone().add(gradientVect[1]).multiplyScalar(0.5);

	if (html.style.setProperty) {
		html.style.setProperty('--color', colorData.colorHex);
		html.style.setProperty('--gradient-start', gradient[0]);
		html.style.setProperty('--gradient-stop', gradient[1]);
		html.style.setProperty('--gradient-mid', rgbToHex(gradienMid));
	}

	pw.classList.add('global-' + colorData.color);
}

var _init = function() {
	html = document.getElementsByTagName('html')[0];

	_handleStore();
	colorStore.subscribe(_handleStore);
}

_init();